import { Stack, Tooltip, Typography } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { Key } from 'lucide-react'
import { FormattedMessage } from 'react-intl'
import { TaskTypeStyles } from './styles'

export const GrantTaskComponent: React.FC = () => (
    <Stack direction="row" spacing={1} alignItems="center">
        <C1Icon icon={Key} sx={TaskTypeStyles.grantIcon} size="sm" />
        <Typography>
            <FormattedMessage id="task_type_request" defaultMessage="Request" />
        </Typography>
    </Stack>
)

export const GrantTaskIcon: React.FC = () => (
    <Tooltip title={<FormattedMessage id="task_type_request" defaultMessage="Request" />} placement="top">
        <C1Icon icon={Key} sx={TaskTypeStyles.grantIcon} size="sm" />
    </Tooltip>
)
